import { Visualize3dObject, getComponent } from '../../models/visualize3d-object';
import { OnObject3dInit } from '../../view-interactions/object-3d-events';
import { Injectable } from '@angular/core';
import type { SpotLightComponent } from '../spot-light-component';
import { Color, Object3D, SpotLight } from 'three';

@Injectable({
  providedIn: 'root',
})
export class SpotLightComponentHandler implements OnObject3dInit {
  initialize(object3d: Object3D, v3dObject: Visualize3dObject): void {
    const component = getComponent<SpotLightComponent>(v3dObject, 'SpotLight');
    if (!component) {
      return;
    }
    const light = new SpotLight();
    for (const key in component) {
      light[key] = component[key];
    }
    light.color = new Color(component.color);
    object3d.add(light);
  }
}
